import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateActivityStageMutation as UpdateActivityStageMutationType,
  UpdateActivityStageMutationVariables,
} from "./__generated__/UpdateActivityStageMutation";

const UpdateActivityStageMutation = loader("./UpdateActivityStageMutation.gql");

type UpdateActivityStageMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateActivityStageMutationType) => void;
}) => ReactElement;

export const UpdateActivityStageMutationProvider: UpdateActivityStageMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateActivityStageMutationType, UpdateActivityStageMutationVariables>(
    UpdateActivityStageMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
